import { getRequestApi } from "../libs/request";

const headers = {
    "X-MBX-APIKEY": process.env.REACT_APP_BINANCE_API_KEY,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true
    //"Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
}

const getFuturesKlines = async (symbol, interval, limit = 1) => {
    let url = `/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`;
    return getRequestApi(url, {}, headers);
}

const getFuturesKlinesWithDate = async (symbol, interval, limit = 1, startTime, endTime) => {
    let url = `/klines?symbol=${symbol}&interval=${interval}&limit=${limit}&startTime=${startTime}&endTime=${endTime}`;
    return getRequestApi(url, {}, headers);
}

const getSpotKlines = async (symbol, interval, limit = 1) => {
    let url = `${process.env.REACT_APP_BINANCE_SPOT_API_BASE_URL}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`;
    return getRequestApi(url);
}

export const binanceService = {
    getFuturesKlines,
    getFuturesKlinesWithDate,
    getSpotKlines
};